/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import moment from 'moment'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import FromToPicker from '../BaseComponent/FromToPicker'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import SearchableCombo from '../BaseComponent/searchableCombo'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {accounting} from 'accounting'
import Loader from '../loaders/loader'

class ReportForMali extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lengthProducts: 0,
      listPaid: [],
      printInfo: [],
      Drivers: [],
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',
      buttonClicked: false,
      driverId: '',
      toTarikh: '',
      fromTarikh: '',
      fishTarikhMin: '',
      fishTarikhMax: '',
      fromPayDate: '',
      toPayDate: '',
      loading: false
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      listPaid: data
    })
  }

  changeDropDown(data) {
    this.setState({
      listPaid: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }
  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  fromTarikh = (fromTarikh) => {
    this.setState({
      fromTarikh
    })
  }

  toTarikh = (toTarikh) => {
    this.setState({
      toTarikh
    })
  }
  fromPayDate = (fromPayDate) => {
    this.setState({
      fromPayDate
    })
  }

  toPayDate = (toPayDate) => {
    this.setState({
      toPayDate
    })
  }
  fromFishDate = (fishTarikhMin) => {
    this.setState({
      fishTarikhMin
    })
  }
  toFishDate = (fishTarikhMax) => {
    this.setState({
      fishTarikhMax
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())

    let bedMin = this.convertDigit(document.getElementById('bedMin').value.trim())
    let bedMax = this.convertDigit(document.getElementById('bedMax').value.trim())

    let besMin = this.convertDigit(document.getElementById('besMin').value.trim())
    let besMax = this.convertDigit(document.getElementById('besMax').value.trim())

    let description = document.getElementById('description').value.trim()
    let sharh = document.getElementById('sharh').value.trim()
    let fishNo = document.getElementById('fishNo').value.trim()

    var tarikhMin = this.state.fromTarikh

    var tarikhMax = this.state.toTarikh

    var fishTarikhMin = this.state.fishTarikhMin

    var fishTarikhMax = this.state.fishTarikhMax

    var payDateMin = this.state.fromPayDate

    var payDateMax = this.state.toPayDate

    if (
      fishTarikhMin === '' &&
      fishTarikhMax === '' &&
      bedMin === '' &&
      bedMax === '' &&
      besMax === '' &&
      besMin === '' &&
      payDateMax === '' &&
      payDateMin === '' &&
      fishNo === '' &&
      sharh === '' &&
      description === '' &&
      tarikhMin === '' &&
      tarikhMax === '' &&
      invoiceId === ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if (tarikhMin === '' || tarikhMax === '') {
      message.error('تاریخ های الزامی وارد شود')
    } else if ((tarikhMin !== '' || tarikhMin === null) && isNaN(tarikhMin)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((tarikhMax !== '' || tarikhMax === null) && isNaN(tarikhMax)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if ((payDateMin !== '' || payDateMin === null) && isNaN(payDateMin)) {
      message.error('فرمت تاریخ ابتدای پرداخت صحیح نیست')
    } else if ((payDateMax !== '' || payDateMax === null) && isNaN(payDateMax)) {
      message.error('فرمت تاریخ انتهای پرداخت صحیح نیست')
    } else {
      this.setState({
        toPrintDate: this.state.fromTarikh === '' ? '-' : jMoment(this.state.fromTarikh).format('jYY/jMM/jDD'),
        fromPrintDate: this.state.toTarikh === '' ? '-' : jMoment(this.state.toTarikh).format('jYY/jMM/jDD'),
        loading: true
      })

      sessionStorage.setItem(
        'params',
        `fishTarikhMax=${fishTarikhMax !== '' ? fishTarikhMax : ''}&fishTarikhMin=${
          fishTarikhMin !== '' ? fishTarikhMin : ''
        }&besMin=${besMin}&besMax=${besMax}&bedMin=${bedMin}&bedMax=${bedMax}&fishNo=${fishNo}&sharh=${sharh}&payDateMin=${payDateMin}&payDateMax=${payDateMax}&description=${description}&tarikhMin=${
          tarikhMin !== '' ? tarikhMin : ''
        }&tarikhMax=${tarikhMax !== '' ? tarikhMax : ''}&invoiceId=${invoiceId}&sortBy=tarikh_Desc`
      )

      http
        .get(
          `${REPORT_RETAIL.REPORT_RETAIL_PAYMENTFORMALI}?export=false&pageSize=10&pageNumber=1&${sessionStorage.getItem(
            'params'
          )}`,
          {}
        )
        .then((response) => {
          if (response.data.error === null) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              listPaid: response.data.object.result,
              lengthProducts: response.data.object.countAll,
              buttonClicked: true,
              loading: false
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            this.setState({
              loading: false
            })
            // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
          this.setState({
            loading: false
          })
        })
    }
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_PAYMENTFORMALI}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            // .dispatch.dispatchDate

            if (excelReport[i]['verifyDate'] === null) {
              excelReport[i]['verifyDate'] = ''
            } else {
              excelReport[i]['verifyDate'] = jMoment(excelReport[i]['verifyDate']).format('jYY/jMM/jDD HH:mm')
            }

            if (excelReport[i]['tarikh'] === null) {
              excelReport[i]['tarikh'] = ''
            } else {
              excelReport[i]['tarikh'] = jMoment(excelReport[i]['tarikh']).format('jYY/jMM/jDD')
            }

            if (excelReport[i]['payDate'] === null) {
              excelReport[i]['payDate'] = ''
            } else {
              excelReport[i]['payDate'] = jMoment(excelReport[i]['payDate']).format('jYY/jMM/jDD HH:mm')
            }
            excelReport[i]['discriminator'] = this.convertDescrimator(excelReport[i]['discriminator'])
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PAYMENTFORMALI}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            printInfo: response.data.object.result
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  convertDescrimator = (value) => {
    switch (value) {
      case 'CashPayment':
        return 'پرداخت نقدی'
      case 'GiftPayment':
        return 'پرداخت هدیه'
      case 'OnlinePayment':
        return 'پرداخت آنلاین'
      case 'BankTransfer':
        return 'Pos'
      default:
        return ''
    }
  }

  render() {
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let excelColumns = [
      {title: 'شناسه', value: 'deliveryPackId'},
      {title: 'شناسه فاکتور', value: 'invoiceId'},
      {title: 'حالت', value: 'state'},
      {title: 'رساننده', value: 'capacity'},
      {title: 'خودرو', value: 'plateNumber'},
      {title: 'زمان تحویل', value: 'plateText'}
    ]
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'عطف',
      'تاریخ',
      'بدهکار',
      'بستانکار',
      'شرح',
      'شماره فیش',
      'تاریخ فیش',
      'توضیحات',
      'شناسه فاکتور',
      'تاریخ تایید',
      'نتیجه تایید',
      'شماره دریافت',
      'نوع پرداخت',
      'تاریخ پرداخت',
      'پرداخت کننده',
      'تخفیف',
      'تخفیف هدیه'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش دریافتی مالی"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={18}
              rightColSpan={8}
              centerColSpan={1}
              leftColSpan={9}
              centerSection={''}
              rightSection={'تاریخ از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{list.atf}</td>
                  <td>{jMoment(list.tarikh).format('jYYYY/jM/jD')}</td>
                  <td className="priceCell">{accounting.formatMoney(list.bed, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(list.bes, '', ',')}</td>
                  <td>{list.sharh}</td>
                  <td>{list.fishNo}</td>
                  <td>{list.fishTarikh}</td>
                  <td>{list.description}</td>
                  <td>
                    <Link
                      to={{
                        pathname: '/baskets',
                        search: `?invoiceId=${list.invoiceId}&userCode=${''}`
                      }}
                      target={'_blank'}
                    >
                      {list.invoiceId}
                    </Link>
                  </td>
                  <td>{list.verifyDate === null ? '-' : jMoment(list.verifyDate).format('jYYYY/jM/jD')}</td>
                  <td>{list.verifyResult}</td>
                  <td>{list.receiptNumber}</td>
                  <td>{this.convertDescrimator(list.discriminator)}</td>
                  <td>{list.payDate === null ? '-' : jMoment(list.payDate).format('jYYYY/jM/jD')}</td>
                  <td>{list.payer}</td>
                  <td className="priceCell">{accounting.formatMoney(list.discount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(list.giftDiscount, '', ',')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش دریافتی مالی.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'atf'}
                field={'atf'}
                title={'عطف'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'tarikh'}
                field={'tarikh'}
                title={'تاریخ'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bed'}
                field={'bed'}
                title={'بدهکار'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'bes'}
                field={'bes'}
                title={'بستانکار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'sharh'}
                field={'sharh'}
                title={'شرح'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'fishNo'}
                field={'fishNo'}
                title={'شماره فیش'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'fishTarikh'}
                field={'fishTarikh'}
                title={'تاریخ فیش'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'description'}
                field={'description'}
                title={'توضیحات'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'verifyDate'}
                field={'verifyDate'}
                title={'تاریخ تایید'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'verifyResult'}
                field={'verifyResult'}
                title={'نتیجه تایید'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'receiptNumber'}
                field={'receiptNumber'}
                title={'شماره دریافت'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'discriminator'}
                field={'discriminator'}
                title={'نوع پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'payDate'}
                field={'payDate'}
                title={'تاریخ پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'payer'}
                field={'payer'}
                title={'پرداخت کننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'discount'}
                field={'discount'}
                title={'تخفیف'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'giftDiscount'}
                field={'giftDiscount'}
                title={'تخفیف هدیه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>دریافتی مالی</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={REPORT_RETAIL.REPORT_RETAIL_PAYMENTFORMALI}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_RETAIL.REPORT_RETAIL_PAYMENTFORMALI + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.fromTarikh}
                  onChangeToDate={this.toTarikh}
                  fromLabel=" تاریخ  از"
                  toLabel=" تاریخ  تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                  force
                />

                <FromToPicker
                  onChangeFromDate={this.fromPayDate}
                  onChangeToDate={this.toPayDate}
                  fromLabel=" تاریخ پرداخت از"
                  toLabel=" تاریخ پرداخت تا"
                  defaulValue={false}
                  fromId="fromPay"
                  toId="toPay"
                />

                <div className="formComponent">
                  <label>شناسه فاکتور</label>
                  <input className="form-control" id="invoiceId" type="text" />
                </div>

                <div className="formComponent">
                  <label>توضیحات</label>
                  <input className="form-control" id="description" type="text" />
                </div>

                <div className="formComponent">
                  <label>شرح</label>
                  <input className="form-control" id="sharh" type="text" />
                </div>

                <div className="formComponent">
                  <label>شماره فیش</label>
                  <input className="form-control" id="fishNo" type="text" />
                </div>

                <FromToPicker
                  onChangeFromDate={this.fromFishDate}
                  onChangeToDate={this.toFishDate}
                  fromLabel=" تاریخ فیش از"
                  toLabel=" تاریخ فیش تا"
                  defaulValue={false}
                  fromId="fromfish"
                  toId="tofish"
                />

                <div className="formComponent">
                  <label>مبلغ بدهکار از</label>
                  <input className="form-control" id="bedMin" type="text" />
                </div>

                <div className="formComponent">
                  <label>مبلغ بدهکار تا</label>
                  <input className="form-control" id="bedMax" type="text" />
                </div>

                <div className="formComponent">
                  <label>مبلغ بستانکار از</label>
                  <input className="form-control" id="besMin" type="text" />
                </div>

                <div className="formComponent">
                  <label>مبلغ بستانکار تا</label>
                  <input className="form-control" id="besMax" type="text" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عطف</td>
                    <td>تاریخ</td>
                    <td>بدهکار</td>
                    <td>بستانکار</td>
                    <td>شرح</td>
                    <td>شماره فیش</td>
                    <td>تاریخ فیش</td>
                    <td>توضیحات</td>
                    <td>شناسه فاکتور</td>
                    <td>تاریخ تایید</td>
                    <td>نتیجه تایید</td>
                    <td>شماره دریافت</td>
                    <td>نوع پرداخت</td>
                    <td>تاریخ پرداخت</td>
                    <td> پرداخت کننده</td>
                    <td>تخفیف</td>
                    <td>تخفیف هدیه</td>
                  </tr>
                  {this.state.listPaid.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.atf}</td>
                      <td>{jMoment(list.tarikh).format('jYYYY/jM/jD')}</td>
                      <td className="priceCell">{accounting.formatMoney(list.bed, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(list.bes, '', ',')}</td>
                      <td>{list.sharh}</td>
                      <td>{list.fishNo}</td>
                      <td>{list.fishTarikh}</td>
                      <td>{list.description}</td>
                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?invoiceId=${list.invoiceId}&userCode=${''}`
                          }}
                          target={'_blank'}
                        >
                          {list.invoiceId}
                        </Link>
                      </td>
                      <td>{list.verifyDate === null ? '-' : jMoment(list.verifyDate).format('jYYYY/jM/jD')}</td>
                      <td>{list.verifyResult}</td>
                      <td>{list.receiptNumber}</td>
                      <td>{this.convertDescrimator(list.discriminator)}</td>
                      <td>{list.payDate === null ? '-' : jMoment(list.payDate).format('jYYYY/jM/jD')}</td>
                      <td>{list.payer}</td>
                      <td className="priceCell">{accounting.formatMoney(list.discount, '', ',')}</td>
                      <td className="priceCell">{accounting.formatMoney(list.giftDiscount, '', ',')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_RETAIL.REPORT_RETAIL_PAYMENTFORMALI}
                  urlParams={urlParams + '&sortBy=planDate_Desc'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ReportForMali
